import { render } from "./MarketReportDetail.vue?vue&type=template&id=7586f3ae&scoped=true"
import script from "./MarketReportDetail.vue?vue&type=script&lang=js"
export * from "./MarketReportDetail.vue?vue&type=script&lang=js"

import "./MarketReportDetail.vue?vue&type=style&index=0&id=7586f3ae&lang=css"
import "./MarketReportDetail.vue?vue&type=style&index=1&id=7586f3ae&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7586f3ae"]])

export default __exports__